import { vehiclesApi } from '@repo/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { getApiErrorMessage } from '@/lib/api/get-api-error-message'

export const useAssignTrailer = () => {
  const queryClient = useQueryClient()
  const { t } = useTranslation(['vehicles', 'common'])

  return useMutation({
    mutationKey: ['assignTrailer'],
    mutationFn: async ({
      trailerId,
      truckId,
    }: {
      trailerId: number
      truckId: number
    }) => {
      return vehiclesApi.assignTrailerToTruck(trailerId, truckId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['vehicles'] })
      toast.success(t('vehicles:toasts.trailerAssignedSuccess'))
    },
    onError: (error: Error) => {
      toast.error(
        getApiErrorMessage(error, t, t('vehicles:toasts.trailerAssignedError')),
      )
    },
  })
}
